module.exports = __webpack_public_path__ + "img/idea-subs.5e3a4712.svg";